import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    url: "https://vpn.csi.kz/auth",
    realm: "aqmola-sic",
    clientId: "aqmola-ea",
});

export default keycloak;